import { useEffect, useState } from "react";
import { cats } from "@/mocks/home";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = [
    { href: "#feed", label: "实时热榜" },
    { href: "#fresh", label: "今日更新" },
    { href: "#topics", label: "分类吃瓜" },
    { href: "#focus", label: "深读专题" },
    { href: "#about", label: "关于本站" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="今天吃瓜首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
            今天吃瓜
            <span className="ml-1 align-middle text-[10px] font-bold text-primary-500">实时</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100"
          >
            投稿
          </a>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            订阅吃瓜提醒
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition hover:bg-secondary-100 lg:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {n.label}
              </a>
            ))}
            <div className="mt-2 grid grid-cols-3 gap-2 border-t border-background-200 pt-3">
              {cats.slice(0, 6).map((c) => (
                <a
                  key={c.name}
                  href="#topics"
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-2 text-center text-xs font-medium text-secondary-900"
                >
                  {c.name}
                </a>
              ))}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}